/* RESPONSIBLE TEAM: team-proactive-support */
import NodeConfiguration, { NODE_CATEGORIES } from 'embercom/objects/series/node-configuration';
import ChecklistInserterConfiguration from 'embercom/objects/series/node/checklist-inserter-configuration';

export default class ChecklistNodeConfiguration extends NodeConfiguration {
  inserterConfiguration = new ChecklistInserterConfiguration();
  category = NODE_CATEGORIES.content;
}
